import styled, { css } from "styled-components";

export const HeaderRoot = styled.nav(
    ({ theme }) => css`
        justify-content: space-between;
        align-items: center;
        padding: ${theme.spacing.all(3, 3, 3, 4)};
        display: flex;
    `,
);

export const HeaderIcon = styled.div<{ color?: string }>(
    ({ color }) => css`
        font-size: 1.8rem;
        color: ${color || "white"};
        cursor: pointer;
    `,
);
